export enum LoyaltySystem {
  No = 0,
  IikoCard = 1,
}

export interface IDiscountMetadata {
  loyaltySystem: LoyaltySystem;
}

export interface IOrganizationMetadata {
  yandexMetricaId: string;
  yandexMapsToken: string;
  discount: IDiscountMetadata;
}
